import React from 'react';
export function ClickIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7v-.5A1.5 1.5 0 0014.5 5H12V1.5A1.5 1.5 0 0010.5 0h-3A1.5 1.5 0 006 1.5v10.839l-1.362-1.557a1.5 1.5 0 00-2.281.028L.47 13.073a1.5 1.5 0 00-.096 1.792L5 21.803V24h17v-2.838l1.923-5.769A1.5 1.5 0 0024 14.92V10.5A1.5 1.5 0 0022.5 9H20v-.5A1.5 1.5 0 0018.5 7H16zM8 2v13a1 1 0 01-1.753.659l-2.728-3.12-1.273 1.528 4.586 6.878A1 1 0 017 21.5v.5h13v-1a1 1 0 01.051-.316L22 14.838V11h-2v3h-2V9h-2v4h-2V7h-2v5h-2V2H8z"
  }));
}